// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

// initialize an empty api service that we'll inject endpoints into later as needed
export const institutionalApi = createApi({
  reducerPath: "institutional",
  tagTypes: [
    "User",
    "Onboarding",
    "Onboardings",
    "RouterOrder",
    "RouterNonUsAccounts",
    "Healthcheck",
    "RouterUsAccounts",
    "RouterMXAccounts",
    "RouterSubAccounts",
    "RouterAccounts",
    "RouterOrders",
    "AdminSummary",
    "AdminOrders",
    "AllClients",
    "ShinkansenBalance",
    "AdminDestinationAccounts",
    "RouterAccountsMX",
    "Webhooks",
    "ApiKeys",
    "SuperUserBroker",
    "ShinkansenAccounts",
    "Flags",
    "MexDolarOrderDetails",
    "LPDetails",
    "PurposeOfPayments",
    "OnboardingsStatus",
    "OrderTimeline",
    "UserNotifications",
  ],
  baseQuery: customFetchBase("institutional"),
  endpoints: () => ({}),
});
